"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var next_components_1 = require("@dotdev/next-components");
var Locales = /** @class */ (function (_super) {
    __extends(Locales, _super);
    function Locales(props) {
        return _super.call(this, props) || this;
    }
    Locales.prototype.render = function () {
        var _this = this;
        var children = this.props.children;
        var locales = this.context.state.locales;
        var parts = children && children.includes(".") ? children.split(".") : children;
        var translation = "Translation \"" + children + "\" is missing";
        var translationObject = locales;
        translationObject
            ? (parts.map(function (part) {
                typeof translationObject === "object"
                    ? translationObject && translationObject[part]
                        ? (translationObject = translationObject[part])
                        : _this.props.default
                            ? ((translationObject = _this.props.default),
                                console.warn("Translation \"" + children + "\" was missing and defaulted to \"" + _this.props.default + "\""))
                            : ((translationObject = "Translation \"" + part + "\" is missing in \"" + children + "\""),
                                console.warn("Translation \"" + children + "\" was missing and had no fallback"))
                    : null;
            }),
                (translation = translationObject))
            : null;
        return React.createElement(React.Fragment, null, translation);
    };
    Locales.contextType = next_components_1.ShopifyNext.Context;
    return Locales;
}(React.PureComponent));
exports.Locales = Locales;
